import { useCurrentInstaller } from 'hooks/UseCurrentInstaller';

import { EIV_STATUS_NOT_RELEVANT } from 'global/constants';

export const calcHasEnergy = (installer) =>
  !EIV_STATUS_NOT_RELEVANT.includes(installer?.statusStrom);
export const calcHasGas = (installer) => !EIV_STATUS_NOT_RELEVANT.includes(installer?.statusGas);

export const useInstallerBranchStatus = ({ skipInstaller = false } = {}) => {
  const { installer } = useCurrentInstaller({ skip: skipInstaller });

  return {
    installer,
    hasEnergy: calcHasEnergy(installer),
    hasGas: calcHasGas(installer),
  };
};
